import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import withTranslateProvider from 'src/hoc/with-translate-provider'
import HeadMetaTags from '~/components/HeadMetaTags'
import AboutUsContainer from '~/features/about-us'
import en_about_us from '../../public/locales/en/about-us.json'
import en_request_demo from '../../public/locales/en/request-demo.json'
import jp_about_us from '../../public/locales/ja/about-us.json'
import jp_request_demo from '../../public/locales/ja/request-demo.json'

const AboutUsPage: FC = () => {
  const { t } = useTranslation()

  return (
    <>
      <HeadMetaTags
        title={t('meta:about_us:meta_title')}
        description={t('meta:about_us:meta_description')}
      />
      <AboutUsContainer />
    </>
  )
}

export default withTranslateProvider(AboutUsPage, {
  en: { aboutUs: en_about_us, request_demo: en_request_demo },
  ja: { aboutUs: jp_about_us, request_demo: jp_request_demo }
})
